import {
  BackgroundControlOrder,
  CompanyWithBackgroundControl,
} from '@ansvar-sakerhet/api-client';

export function getLatestOrder(
  company: CompanyWithBackgroundControl
): BackgroundControlOrder | undefined {
  return [...company.BackgroundControlOrder].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )[0];
}

function getLatestReportFileDate(company: CompanyWithBackgroundControl) {
  const reportFiles = company.backgroundControls.flatMap(
    (backgroundControl) => backgroundControl.reportFiles
  );

  const latestReportFile = [...reportFiles].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  )[0];

  return latestReportFile ? new Date(latestReportFile.createdAt) : undefined;
}

export function isOrderPending(company: CompanyWithBackgroundControl) {
  const latestOrder = getLatestOrder(company);

  if (!latestOrder) return false;

  const latestReportDate = getLatestReportFileDate(company);

  if (!latestReportDate) return true;

  return new Date(latestOrder.createdAt).getTime() > latestReportDate.getTime();
}
